var toString = Object.prototype.toString;
module.exports = isString;
function isString(obj) {
  return toString.call(obj) === "[object String]";
}